import { render } from "./Residential.vue?vue&type=template&id=057a3d62&scoped=true"
import script from "./Residential.vue?vue&type=script&lang=js"
export * from "./Residential.vue?vue&type=script&lang=js"

import "./Residential.vue?vue&type=style&index=0&id=057a3d62&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057a3d62"]])

export default __exports__